module.exports = __webpack_public_path__ + "static/media/hero_mobile.dce9ef19.webp";